export const USER_ROLES = [
  { value: 'USER', label: 'USUARIO' },
  { value: 'ANALYST', label: 'ANALISTA' },
  { value: 'ADMIN', label: 'ADMINISTRADOR' },
];
